import { Vector3, Quaternion, Color } from "flavr-math";
import { FacetRenderer } from "../renderable/Renderable";
import { InstanceBatchLineMaterial } from "../instancing/lines/lineMaterials";
const tempPosition = new Vector3();
const tempScaling = new Vector3();
const tempQuaternion = new Quaternion();
const tempColor = new Color();
export class LineStripRenderable extends FacetRenderer {
    constructor() {
        super(...arguments);
        this.instances = [];
    }
    destroy() {
        this.instances.forEach((it) => {
            it.destroy();
        });
        this.instances = [];
    }
    setVisible(visible) {
        this.instances.forEach((it) => {
            it.setVisible(visible);
        });
    }
    updateFacet(facet) {
        var _a, _b, _c;
        this.owner.getWorldTransform(tempPosition, tempQuaternion, tempScaling);
        const averageWorldScale = (tempScaling.x + tempScaling.y + tempScaling.z) / 3;
        const thickness = facet.thickness * averageWorldScale;
        const batch = this.owner.renderer.getLineBatch(this.owner.modelUID, facet.noShading ? InstanceBatchLineMaterial.BASIC_LINE : InstanceBatchLineMaterial.FUZZY_LINE);
        const color = tempColor.setHex(facet.color);
        let lineCount = 0;
        for (let i = 1, len = facet.points.length; i < len; ++i) {
            const startPoint = facet.points[i - 1];
            const endPoint = facet.points[i];
            if (startPoint.length !== 3 || endPoint.length !== 3)
                continue;
            const startPointWorld = tempPosition.fromArray(startPoint).applyMatrix4(this.owner.matrixWorld);
            const endPointWorld = tempScaling.fromArray(endPoint).applyMatrix4(this.owner.matrixWorld);
            while (lineCount >= this.instances.length) {
                this.instances.push(batch.createInstance());
            }
            const instance = this.instances[lineCount];
            ++lineCount;
            instance.setStartPoint(startPointWorld);
            instance.setEndPoint(endPointWorld);
            instance.setThickness(thickness);
            instance.setColor(color);
            instance.setFuzzyness((_a = facet.fussyness) !== null && _a !== void 0 ? _a : 0);
            instance.setNoiseFrequency((_b = facet.noiseFrequency) !== null && _b !== void 0 ? _b : 10);
            instance.setNoiseVelocity((_c = facet.noiseVelocity) !== null && _c !== void 0 ? _c : 0.001);
        }
        while (this.instances.length > lineCount) {
            const instance = this.instances.pop();
            if (instance) {
                instance.destroy();
            }
        }
    }
    updateTransform() {
        if (this.facet === undefined) {
            throw new Error("We expect this.lineStrip to be defined.");
        }
        this.owner.getWorldTransform(tempPosition, tempQuaternion, tempScaling);
        const averageWorldScale = (tempScaling.x + tempScaling.y + tempScaling.z) / 3;
        const thickness = this.facet.thickness * averageWorldScale;
        let instanceIndex = 0;
        for (let i = 1, len = this.facet.points.length; i < len; ++i) {
            const startPoint = this.facet.points[i - 1];
            const endPoint = this.facet.points[i];
            if (startPoint.length !== 3 || endPoint.length !== 3)
                continue;
            const startPointWorld = tempPosition.fromArray(startPoint).applyMatrix4(this.owner.matrixWorld);
            const endPointWorld = tempScaling.fromArray(endPoint).applyMatrix4(this.owner.matrixWorld);
            const instance = this.instances[instanceIndex];
            instance.setStartPoint(startPointWorld);
            instance.setEndPoint(endPointWorld);
            instance.setThickness(thickness);
            ++instanceIndex;
        }
    }
}
